<template>
  <f7-page>
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/tabs-result/', { reloadCurrent: true })"
        >
          {{ $t('LeftPanel_title_result') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ $t('IrrigationPage_navbar_title') }}</span>
      </template>
    </navbar>
    <div v-if="selection === 'GreenHouse'">
      <IrrigationGreenHouse
        :result="resultProject.result"
      />
    </div>
    <div v-else>
      <IrrigationOpenAir :list-irrigation="listIrrigationEx" />
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'vuex';
import navbar from '../../../../components/navbar/NavBar.vue';
import IrrigationGreenHouse from '../../../../components/irrigationResult/index.vue';
import IrrigationOpenAir from '../../../../components/irrigation/irrigationOpenAir/index.vue';

export default {
  name: 'IrrigationResultPageGh',
  components: {
    navbar,
    IrrigationGreenHouse,
    IrrigationOpenAir,
  },
  computed: {
    ...mapState('authentication', [
      'selection',
    ]),
    ...mapState('Result', [
      'resultProject',
    ]),
    selectionClass() {
      return this.selection === 'GreenHouse' ? 'dx-btn-success color-orange' : 'dx-btn-success open-air';
    },
  },
  methods: {
    goToHomePage() {
      this.$f7.views.main.router.navigate('/tabs-result-greenhouse/');
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
